const delimiter = "----------";

export const appendIfPresent = (
  target: string,
  values: Record<string, string | string[]>
) => {
  target += `\n${  delimiter}`;
  Object.entries(values).forEach(([key, value]) => {
    if (value)
      {target += `|\n${key}: ${
        Array.isArray(value) ? JSON.stringify(value) : value
      }`;}
  });

  return target;
};

export const getBodyAndFields = (formattedBody: string) => {
  const [body, rest] = formattedBody.split(delimiter);
  const substring = rest
    ?.split("|\n")
    .filter(field => !!field && !field.toLowerCase().includes("call id"));

  const fields: Record<string, string> = Object.fromEntries(
    substring.map(field => {
      const [key = "", value = ""] = field?.split(": ") ?? [];
      try {
        const parsed = JSON.parse(value);
        return [key, Array.isArray(parsed) ? parsed.join(", ") : value];
      } catch {
        return [key, value];
      }
    })
  );

  return { body, fields };
};
